module.exports = __webpack_public_path__ + "img/Key'n Go.bceb58e4.gif";